//***************************
//PRODUCT GALLERY
//***************************

//Gallery box
var galleryBox = document.getElementById('wpk-gallery-image'); 
//Gallery thumbnails container
var galleryList = document.getElementById('wpk-gallery-thumbnails'); 

//If we have a product with thumbnail images in gallery
if (galleryBox && galleryList) {

	//EventListener on parent ul for performance
	galleryList.addEventListener('click', function(event) {
		//If the child click is a image
		if (event.target && event.target.matches('img')) {
			event.preventDefault();
			var img = event.target;
			var imgSrc = img.src;
			var imgSrcLarge = img.dataset.large;

			//Set main image src from thumbnail image values
			if(imgSrcLarge) {
				galleryBox.src = imgSrcLarge;
			} else {
				galleryBox.src = imgSrc;
			}
			//Set main image srcset from thumbnail image values
			galleryBox.srcset = imgSrcLarge;
		}
	});
}